import styled from 'styled-components';
import {
    APP_TOOLTIP_BODY_WEIGHT,
    APP_TOOLTIP_FONT_FAMILY,
    APP_TOOLTIP_FONT_SIZE,
    APP_TOOLTIP_LINE_HEIGHT,
} from '../../../../../theme/appTooltipTypography';

export const SmartDefaultsRoot = styled.div`
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(244, 91, 104, 0.18);
  border-radius: 16px;
  background: var(--app-surface);
  padding: 24px 28px;
  margin-bottom: 24px;
`;

export const SmartDefaultsHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
  position: relative;
  z-index: 1;

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

export const SmartDefaultsStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #f45b68;
  margin-bottom: 8px;
`;

export const SmartDefaultsStatusDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #22c55e;
  flex-shrink: 0;
`;

export const SmartDefaultsTitle = styled.h2`
  margin: 0 0 8px;
  font-size: 1.35rem;
  font-weight: 700;
  color: var(--app-text);
  line-height: 1.3;
`;

export const SmartDefaultsDescription = styled.p`
  margin: 0;
  max-width: 640px;
  font-size: 0.875rem;
  line-height: 1.55;
  color: var(--app-text-muted);
`;

export const SmartDefaultsChips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  position: relative;
  z-index: 1;
`;

export const SmartDefaultsChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px;
  border: 1px solid var(--app-border);
  border-radius: 8px;
  background: var(--app-surface-alt);
  font-size: 0.8125rem;
  white-space: nowrap;
`;

export const SmartDefaultsChipLabel = styled.span`
  color: var(--app-text-muted);
`;

export const SmartDefaultsChipValue = styled.span`
  font-weight: 700;
  color: var(--app-text);
`;

export const EditDefaultsModalBody = styled.div`
  .smart-defaults-modal-label {
    display: block;
    margin-bottom: 8px;
    font-size: 0.875rem;
    font-weight: 600;
    color: var(--app-text);
  }

  .smart-defaults-modal-label-hint {
    font-weight: 400;
    color: var(--app-text-muted);
  }

  .smart-defaults-info-box {
    display: flex;
    gap: 12px;
    align-items: flex-start;
    padding: 14px 16px;
    border-radius: 10px;
    background: rgba(59, 130, 246, 0.08);
    border: 1px solid rgba(59, 130, 246, 0.18);
    font-size: 0.8125rem;
    line-height: 1.5;
    color: var(--app-text-muted);
  }

  .smart-defaults-field-warning {
    display: flex;
    gap: 6px;
    align-items: flex-start;
    font-family: ${APP_TOOLTIP_FONT_FAMILY};
    font-size: ${APP_TOOLTIP_FONT_SIZE};
    font-weight: ${APP_TOOLTIP_BODY_WEIGHT};
    line-height: ${APP_TOOLTIP_LINE_HEIGHT};
    color: #b45309;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .smart-defaults-field-warning--inline {
    margin-top: 6px;
  }

  .smart-defaults-field-warning__icon {
    flex-shrink: 0;
    margin-top: 3px;
    font-size: 13px;
    color: #d97706;
  }

  [data-bs-theme='dark'] & .smart-defaults-field-warning {
    color: #fbbf24;
  }

  [data-bs-theme='dark'] & .smart-defaults-field-warning__icon {
    color: #fbbf24;
  }

  .ant-form-item-extra {
    min-height: 0;
    margin-top: 0;
  }

  .smart-defaults-modal-actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
    margin-top: 24px;
  }

  .smart-defaults-cancel-btn {
    border: none;
    background: transparent;
    color: var(--app-text-muted);
    font-weight: 600;
    cursor: pointer;
    padding: 8px 12px;

    &:hover {
      color: var(--app-text);
    }
  }

  .smart-defaults-save-btn {
    border: none;
    border-radius: 10px;
    padding: 10px 20px;
    font-weight: 600;
    color: #fff;
    background: #f45b68;
    cursor: pointer;
    box-shadow: 0 4px 14px rgba(244, 91, 104, 0.25);

    &:hover:not(:disabled) {
      background: #e04a57;
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
`;

export const HeadsUpModalBody = styled.div`
  .heads-up-label {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #f45b68;
    margin-bottom: 8px;
  }

  .heads-up-title {
    margin: 0 0 10px;
    font-size: 1.35rem;
    font-weight: 700;
    color: var(--app-text);
    line-height: 1.3;
  }

  .heads-up-description {
    margin: 0 0 24px;
    font-size: 0.875rem;
    line-height: 1.55;
    color: var(--app-text-muted);
  }

  .heads-up-options {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 24px;
  }

  .heads-up-option {
    width: 100%;
    text-align: left;
    border: 1.5px solid var(--app-border);
    border-radius: 14px;
    padding: 16px 18px;
    background: var(--app-surface);
    cursor: pointer;
    transition: border-color 0.2s ease, background 0.2s ease;

    &:hover {
      border-color: rgba(244, 91, 104, 0.45);
    }

    &.heads-up-option--recommended {
      border-color: rgba(244, 91, 104, 0.35);
    }

    &.heads-up-option--overwrite {
      background: rgba(244, 91, 104, 0.06);
      border-color: rgba(244, 91, 104, 0.45);
    }

    &.heads-up-option--selected {
      border-color: #f45b68;
      box-shadow: 0 0 0 1px rgba(244, 91, 104, 0.15);
    }

    &.heads-up-option--selected.heads-up-option--overwrite {
      background: rgba(244, 91, 104, 0.1);
    }
  }

  .heads-up-option-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 6px;
  }

  .heads-up-option-title {
    font-size: 0.9375rem;
    font-weight: 700;
    color: var(--app-text);
  }

  .heads-up-recommended-badge {
    flex-shrink: 0;
    padding: 3px 10px;
    border-radius: 999px;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #fff;
    background: #22c55e;
  }

  .heads-up-option-desc {
    margin: 0;
    font-size: 0.8125rem;
    line-height: 1.5;
    color: var(--app-text-muted);
  }

  .heads-up-modal-actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
  }

  .heads-up-cancel-btn {
    border: none;
    background: transparent;
    color: var(--app-text-muted);
    font-weight: 600;
    cursor: pointer;
    padding: 8px 12px;

    &:hover:not(:disabled) {
      color: var(--app-text);
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .heads-up-confirm-btn {
    border: none;
    border-radius: 10px;
    padding: 10px 20px;
    font-weight: 600;
    color: #fff;
    background: #f45b68;
    cursor: pointer;
    box-shadow: 0 4px 14px rgba(244, 91, 104, 0.25);

    &:hover:not(:disabled) {
      background: #e04a57;
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
`;

export const SmartDefaultsModalEyebrow = styled.div`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #f45b68;
  margin-bottom: 6px;
`;

export const SmartDefaultsModalTitle = styled.h2`
  margin: 0 0 10px;
  font-size: 1.35rem;
  font-weight: 700;
  color: var(--app-text);
`;

export const SmartDefaultsModalDescription = styled.p`
  margin: 0 0 24px;
  font-size: 0.875rem;
  line-height: 1.55;
  color: var(--app-text-muted);
`;
